import axios from "axios";
import router from "@/router";
import Swal from 'sweetalert2';
import store from "./store";

axios.defaults.baseURL = "https://api.oneagency.ch";   
const axiosInstance = axios.create({
  baseURL: axios.defaults.baseURL,   
  headers: {
    "Content-type": "application/json",
    "Accept": "application/json"
  }
});

axios.defaults.withCredentials = true; 
axiosInstance.defaults.handleRouting = true;

axiosInstance.interceptors.response.use(
    (response) => {
        return response;
    },
    async (error) => {
        const { status } = error.response;
        const { message } = error.response.data;

        if (status === 401) { 
            localStorage.removeItem("token");
            localStorage.removeItem("loggedUser");
            
            if (router.currentRoute.name !== "login") {
                router.push({ name: "login" });
            }
            Swal.fire({
                icon: "error",
                title: "Unauthorized",
                text: message || "Please log in to continue.",
            });

            try {
              await store.dispatch('auth/refreshToken');
            } catch (refreshError) { 
                console.error("Failed to refresh token:", refreshError);
            }
        } else if (status === 403 && axiosInstance.defaults.handleRouting) { 
            router.push({ name: "dashboard" });
            Swal.fire({
                icon: "error",
                title: "Forbidden",
                text: message || "You do not have permission to access this page.",
            });
        } else if (status === 500) {
            Swal.fire({
                icon: "error",
                title: "Server Error",
                text: "Something went wrong. Please try again later.",
            });
        }

        return Promise.reject(error);
    }
);

export default ({ requiresAuth = true, handleRouting = true }) => {
  if (requiresAuth) {
    axiosInstance.defaults.headers.common[
      "Authorization"
    ] = `Bearer ${localStorage.getItem("token")}`;
  }
  
  axiosInstance.defaults.handleRouting = handleRouting;
  return axiosInstance;
};